import { defineStore } from "pinia";
import Services from '@/services/administrativeDataServices'
import { mapAdministrativeData } from '@/helpers/mapFuncs'

export const useAdministrativeDataStore = defineStore("administrativeData", {

state:()=>({
    administrative: {},
    administratives: [],
}),
getters : {
    getAdministrative() {
        return mapAdministrativeData(this.administrative)
    },
    getAdministratives() {
        return this.administratives.map(mapAdministrativeData)
    }
},
actions : {
    /** Start Sets */
    setAdministrative(administrative) {
        this.administrative = administrative
    },
    setAdministratives(administratives) {
        this.administratives = administratives
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setAdministrative(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setAdministrative(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setAdministratives(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.administratives.push(response.data)
            return mapAdministrativeData(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.administratives[this.administratives.findIndex((x)=>x.id == id)] = response.data
            return mapAdministrativeData(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.administratives = this.administratives.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});